module.exports = __webpack_public_path__ + "static/media/doulanshan4.549ff266.webp";